// extracted by mini-css-extract-plugin
export default {"bottomBagContainer":"BottomBag_bottomBagContainer__doNKN","bagContent":"BottomBag_bagContent__ZJRL2","cartPrice":"BottomBag_cartPrice__UQqHL","clearBtn":"BottomBag_clearBtn__8mGP+"};